import values from 'lowscore/values.js'
import compact from 'lowscore/compact.js'
import parseDate from '../../../../packages/dates/parse.js'
import LocalDate from '@booking-services/localDate'
import stringFormat from 'root-core/utils/text/stringFormatFilter.js'

export default class MultiCityValidationRules {
  constructor (rootModel, model) {
    var self = this
    this.model = model
    this.rootModel = rootModel
    var errorMessages = rootModel.config.errorMessages
    var departure = rootModel.departure
    var dateFormat = rootModel.config.dateFormat
    this.config = rootModel.config

    function setError (name, error) {
      model.validationErrors = model.validationErrors || {}
      model.validationErrors[name] = error
    }

    function areAirportsTheSame (departureAirport, arriveAirport) {
      return (
        departureAirport !== undefined &&
        arriveAirport !== undefined &&
        departureAirport === arriveAirport
      )
    }

    this.rules = {
      departureAirport (e) {
        var error
        var shouldValidate = !e || !e.target.getAttribute('autoCompleteOpen')
        if (shouldValidate) {
          if (rootModel.allAirports.indexOf(model.departureAirport) === -1)
            error = errorMessages.flightDepartureAirport

          if (areAirportsTheSame(model.departureAirport, model.arriveAirport))
            error = errorMessages.flightArriveDepartureSameAirport
        }

        setError('departureAirport', error)
      },

      arriveAirport (e) {
        var error
        var shouldValidate = !e || !e.target.getAttribute('autoCompleteOpen')
        if (shouldValidate) {
          if (rootModel.allAirports.indexOf(model.arriveAirport) === -1) {
            error = errorMessages.flightArriveAirport
          } else if (
            self.isLastFlight() &&
            rootModel.homeCountryAirports.indexOf(model.arriveAirport) === -1
          ) {
            error = errorMessages.flightArriveDepartureSameCountry
          } else if (
            areAirportsTheSame(model.departureAirport, model.arriveAirport)
          ) {
            error = errorMessages.flightArriveDepartureSameAirport
          }
        }

        setError('arriveAirport', error)
      },

      departureDate () {
        var hotelBefore = rootModel.selectedHotelBeforeTour
        var hotelAfter = rootModel.selectedHotelAfterTour
        var startDate = departure.startDate
        var endDate = departure.endDate
        if (hotelBefore && hotelBefore.NightsToStay) {
          startDate.add(-hotelBefore.NightsToStay, 'd')
        }
        if (hotelAfter && hotelAfter.NightsToStay) {
          endDate.add(hotelAfter.NightsToStay, 'd')
        }
        var error = null
        if (model.departureDate) {
          var modelIndex = rootModel.exploreFlights.multiCity.indexOf(model)
          var previousFlight =
            rootModel.exploreFlights.multiCity[modelIndex - 1]
          var date = parseDate(model.departureDate, dateFormat)

          if (date) {
            date = LocalDate.fromDate(date).format('YYYY-MM-DD')
            var today = new LocalDate().format('YYYY-MM-DD')
            if (date > startDate.toString() && endDate.toString() > date) {
              error = errorMessages.flightDepartureDate
            } else if (date < today) {
              error = errorMessages.flightDepartureDateInPast
            } else if (previousFlight && date < previousFlight.departureDate) {
              error = errorMessages.multiCityFlightDateSequence
            }
          } else {
            error = stringFormat(errorMessages.dateFormat, dateFormat)
          }
        } else {
          error = stringFormat(errorMessages.required, 'departure date')
        }
        setError('departureDate', error)
      },

      tripNotesRead () {
        var error = null
        if (!model.tripNotesRead) {
          error = errorMessages.flightsTripNotesRead
        }
        setError('tripNotesRead', error)
      },
    }
  }

  isLastFlight () {
    var flights = this.rootModel.exploreFlights.multiCity
    return flights.indexOf(this.model) === flights.length - 1
  }

  validate () {
    var requiredRules = ['departureAirport', 'arriveAirport', 'departureDate']
    if (
      this.config.flights.requireTripNotesRead &&
      this.isLastFlight()
    ) {
      requiredRules.push('tripNotesRead')
    }
    this.model.validationErrors = {}

    requiredRules.forEach(key => {
      this.rules[key]()
    })

    return compact(values(this.model.validationErrors)).length == 0
  }
}
